import {NgModule} from '@angular/core';
import {UnsavedChangesNotifierService} from '@application/helper/unsaved-changes-notifier/unsaved-changes-notifier.service';
import {HttpWeaveProductsService} from '@infrastructure/http/weave-product/http-weave-products.service';
import {WEAVE_PRODUCT} from '@infrastructure/http/weave-product/weave-products.interface';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {CanShowErrorForFormControlModule} from '@vdw/angular-component-library';
import {AgGridModule} from 'ag-grid-angular';
import {AddWeaveProductPageComponent} from './add/add-weave-product-page.component';
import {WeaveProductOverviewPageComponent} from './overview/weave-product-overview-page.component';
import {weaveProductRouting} from './weave-product.routing';

@NgModule({
  imports: [TextileDataSharedModule, AgGridModule, weaveProductRouting, CanShowErrorForFormControlModule],
  providers: [{provide: WEAVE_PRODUCT, useClass: HttpWeaveProductsService}, UnsavedChangesNotifierService],
  declarations: [AddWeaveProductPageComponent, WeaveProductOverviewPageComponent]
})
export class WeaveProductModule {}
